import { render, staticRenderFns } from "./PowerBIReportsPage.vue?vue&type=template&id=36b8a4a6&"
import script from "./PowerBIReportsPage.vue?vue&type=script&lang=js&"
export * from "./PowerBIReportsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports